import { DataTable } from 'simple-datatables';

export default () => {
  // Tear down first: this runs on every `turbo:load` and again from controllers
  // whose datatable target connects later, so a table can be initialized more
  // than once. The library tolerates that without duplicating its chrome, but
  // the superseded instance and its window resize listener would otherwise be
  // kept alive by nothing. `destroy()` removes that listener and restores each
  // table's original markup, so the query below still finds pristine elements.
  (window.dataTables || []).forEach((dataTable) => dataTable.destroy());
  window.dataTables = [];

  const dataTableElements = document.querySelectorAll('.datatable');

  if (dataTableElements) {
    dataTableElements.forEach((element) => {
      // Built per element, so options read from one table's data attributes do
      // not leak into the tables initialized after it.
      const dataTableOptions = {
        fixedHeight: false,
        searchable: false,
        paging: false,
        sortable: true,
        perPageSelect: false,
        nextPrev: false,
      };

      if (element.dataset.datatablesSearch) {
        dataTableOptions.searchable = element.dataset.datatablesSearch === 'true';
      }
      if (element.dataset.datatablesPaging) {
        dataTableOptions.paging = true;
        dataTableOptions.perPage = parseInt(element.dataset.datatablesPaging, 10);
      }
      if (element.dataset.datatablesSortable) {
        dataTableOptions.sortable = element.dataset.datatablesSortable === 'true';
      }
      if (element.dataset.datatablesPerPageSelect) {
        dataTableOptions.perPageSelect = element.dataset.datatablesPerPageSelect === 'true';
      }
      if (element.dataset.datatablesFixedHeight) {
        dataTableOptions.fixedHeight = element.dataset.datatablesFixedHeight === 'true';
      }
      if (element.dataset.datatablesNextPrev) {
        dataTableOptions.nextPrev = element.dataset.datatablesNextPrev === 'true';
      }
      window.dataTables.push(new DataTable(element, dataTableOptions));
    });
  }
};
